import { useEffect, useState } from "react";

const Toggle = props => {
  const items = props.options || [];
  const title = props.title || "";

  const [isLeft, setIsLeft] = useState(true);

  useEffect(() => {
    if (isLeft !== props.defaultLeft) {
      setIsLeft(props.defaultLeft);
    }
  }, [props.defaultLeft]);

  if (!items.length || items.length !== 2) {
    return <></>;
  }

  const switchToggle = () => {
    if (props.disabled) {
      return;
    }

    setIsLeft(!isLeft);
    try {
      if (props.onChange !== undefined) {
        props.onChange(isLeft ? items[1] : items[0]);
      }
    } catch (error) {
      console.warn(`Invalid prop for onChange provided to Toggle`);
    }
  };

  return (
    <div className={props.disabled ? "toggle disabled" : "toggle"}>
      {title && <div className="toggle-label">{title}</div>}
      <div className={isLeft ? "toggle-option-selected" : "toggle-option"}>
        {items[0]}
      </div>
      <div className="toggle-box" onClick={switchToggle}>
        <div
          className="toggle-circle"
          style={{ marginLeft: isLeft ? "0" : "auto" }}
        ></div>
      </div>
      <div className={isLeft ? "toggle-option" : "toggle-option-selected"}>
        {items[1]}
      </div>
    </div>
  );
};

export default Toggle;
